import React from 'react';
import { Box, useMediaQuery, Pagination } from '@mui/material';
import { useTheme } from '@mui/system';

interface PaginationBottomProps {
  totalDeals: number;
  minDealsToPaginate: number;
  totalPages: number;
  page: number;
  isFiltered: boolean;
  hasNoItems: boolean;
  handlePageChange: (event: React.ChangeEvent<unknown>, value: number) => void;
}

const PaginationBottom = ({
  totalDeals,
  minDealsToPaginate,
  totalPages,
  page,
  isFiltered,
  hasNoItems,
  handlePageChange
}: PaginationBottomProps) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isExtraSmall = useMediaQuery('(max-width:310px)');
  if (totalDeals <= minDealsToPaginate || (isFiltered && hasNoItems)) {
    return null;
  }

  if (totalPages < 2) {
    return null;
  }

  const mobileSize = isExtraSmall ? 'small' : 'medium';
  const isDarkMode = theme.palette.mode === 'dark';

  return (
    <Box display="flex" justifyContent="center" mt={2} mb={0}>
      <Pagination
        variant="outlined"
        count={totalPages}
        page={page}
        onChange={handlePageChange}
        color="primary"
        size={isMobile ? mobileSize : 'large'} // Adjust pagination size for small screens
        siblingCount={isMobile ? 0 : 1}
        boundaryCount={isMobile ? 1 : 2}
        sx={{
          mb: 2,
          '& .MuiPaginationItem-root': {
            color: isDarkMode ? '#bda4f4' : theme.palette.primary.main
          },
          '& .MuiPaginationItem-page.Mui-selected': {
            backgroundColor: isDarkMode
              ? '#bda4f4'
              : theme.palette.primary.main,
            color: isDarkMode
              ? theme.palette.primary.main
              : theme.palette.common.white
          }
        }}
      />
    </Box>
  );
};

export default PaginationBottom;
